const styles = {
  list: { display: 'flex', flexDirection: 'column', gap: '1rem', paddingY: '0.5rem' },
};

export default styles;
